// extracted by mini-css-extract-plugin
export default {"imgList":"styles_imgList__xasFV","giftsWrapper":"styles_giftsWrapper__16mOK","group":"styles_group__9g8tl","close":"styles_close__Zv-Vv","button":"styles_button__UtnC2"};